import React, { useEffect, useRef, useState } from 'react';

const LogoCarousel = ({ logos, title, direction = 'left' }) => {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer || isPaused) return;

    let scrollPosition = direction === 'left' ? 0 : scrollContainer.scrollWidth / 2;
    
    const scroll = () => {
      if (direction === 'left') {
        scrollPosition += 0.5;
        if (scrollPosition >= scrollContainer.scrollWidth / 2) {
          scrollPosition = 0;
        }
      } else {
        scrollPosition -= 0.5;
        if (scrollPosition <= 0) {
          scrollPosition = scrollContainer.scrollWidth / 2;
        }
      }
      scrollContainer.scrollLeft = scrollPosition;
    };

    const intervalId = setInterval(scroll, 20);
    return () => clearInterval(intervalId);
  }, [isPaused, direction]);

  const duplicatedLogos = [...logos, ...logos];

  return (
    <div className="w-full overflow-hidden">
      {title && (
        <h3 className="text-center text-2xl font-semibold text-gray-900 mb-8">{title}</h3>
      )}
      <div
        ref={scrollRef}
        className="flex gap-12 overflow-x-hidden"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {duplicatedLogos.map((logo, index) => (
          <div
            key={`${logo.id}-${index}`}
            className="flex-shrink-0 w-48 h-24 bg-white rounded-lg shadow-md flex items-center justify-center p-6 hover:shadow-xl transition-shadow duration-300 grayscale hover:grayscale-0"
          >
            <img
              src={logo.logo}
              alt={logo.name}
              className="max-w-full max-h-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoCarousel;
